import React, { useState } from "react";

const ImpersonateButton = ({ onClick, isValid }) => {
    const [isClicked, setIsClicked] = useState(false);

    return (<button className="wk-button-full"
        disabled={!isValid || isClicked ? "disabled" : ""}
        id="goButton"
        onClick={() => { setIsClicked(true); onClick(); }}
        tabIndex="-1">Go
    </button>);
};

export default ImpersonateButton;
